import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthRoutes, NonAuthRoutes, Modules } from '../../../enums';
import { AuthContext } from '../../../contexts/AuthContext';
import { redirectBasedOnPermission } from '../../../utils/methods';
import Brand from './Brand';
import LoginIllustrations from './LoginIllustration';
import ForgotPasswordIllustrations from './ForgotPasswordIllustrations';
import ResetPasswordIllustrations from './ResetPasswordIllustrations';
import './index.scss';

interface PublicLayoutProps {
  route: NonAuthRoutes;
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ route, children }) => {
  const { token, permissions, isSystemAdmin } = useContext(AuthContext);

  if (token) {
    return (
      <Navigate
        replace
        to={{
          pathname:
            Modules.home + AuthRoutes.dashboard ||
            Modules.error + NonAuthRoutes.forbidden,
        }}
      />
    );
  }

  let illustration;
  if (route === NonAuthRoutes.login) {
    illustration = <LoginIllustrations />;
  } else if (route === NonAuthRoutes.forgotPassword) {
    illustration = <ForgotPasswordIllustrations />;
  } else if (route === NonAuthRoutes.resetPassword) {
    illustration = <ResetPasswordIllustrations />;
  }

  return (
    <main className="login-main">
      <div className="authentication-wrapper authentication-basic position-relative p-6">
        {illustration}
        <div className="authentication-inner position-relative d-flex justify-content-center align-items-center">
          <div className="card d-flex flex-column w-100">
            <div className="card-body p-6">
              <div className="d-flex justify-content-center align-items-center mb-5">
                <Brand />
              </div>
              {children}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default PublicLayout;
